import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Button } from "../components/ui/button";
import { trackAndNavigate } from "../utils/navigate";

const NotFound = () => {
  useEffect(() => {
    document.title = "Page Not Found | Integro Clinics";
  }, []);

  return (
    <div className="min-h-screen flex flex-col font-sans">
      <Navbar />
      <main className="flex-grow flex items-center justify-center px-4 py-20 bg-gray-50">
        <div className="max-w-lg w-full text-center">

          {/* 404 number */}
          <p
            className="text-[120px] sm:text-[160px] font-extrabold leading-none text-[#005eb8] opacity-20 select-none"
            aria-hidden="true"
          >
            404
          </p>

          {/* Heading */}
          <h1 className="text-3xl sm:text-4xl font-bold text-[#012d5c] mt-2 mb-4">
            Page not found
          </h1>

          {/* Supporting text */}
          <p className="text-gray-600 text-base sm:text-lg leading-relaxed mb-10">
            The page you are looking for does not exist or may have been moved.
            Please check the URL, or use one of the links below to get back on track.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              asChild
              variant="outline"
              className="rounded-lg border-[#005eb8] text-[#005eb8] hover:bg-[#005eb8] hover:text-white px-8 py-3 text-base font-semibold transition-colors"
            >
              <Link to="/">Back to Home</Link>
            </Button>

            <Button
              asChild
              className="rounded-lg bg-[#4caf50] hover:bg-[#3d8b40] text-white px-8 py-3 text-base font-semibold border-none transition-colors"
            >
              <a
                href="https://app.integroclinics.com/v2/registration"
                onClick={(e) => { e.preventDefault(); trackAndNavigate("https://app.integroclinics.com/v2/registration", 'eligibility_start', { entry_point: 'website' }); }}
                rel="noopener noreferrer"
              >
                Check Your Eligibility
              </a>
            </Button>
          </div>

        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
